import $ from "jquery";

import Vars from '../../vars';

import Modal from "../../components/Modal";
import Request from '../../components/request';
import Utils from "../../components/utils";
import Validation from "../classes/Validation";
import Action from "../classes/Action";

class Crm {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $content  : $(),
        $create   : $(),
        $edit     : $(),
        $params   : $(),
        $modal    : $(),
        $form     : $()
    };

    _const = {
        entities : 'crms',
        entity   : 'crm',
        clientId : window.location.href.indexOf('dev.ifacade.ru') != -1 ? 'ac51ef20-e980-42d3-a73f-0604dfc468bc' : '316a8815-1fa5-420a-bb23-d51f6f248bea'
    };

    _args = {
        page : '',
        id   : 0
    };

    _state = {
        items : {},
        item  : {},
        type  : '',
        display_name : '',
        disabledFields : {},
        count : {},
        isCorrect : false,
        popup     : {
            amo      : null,
            state    : null,
            listener : false
        }
    };

    _actions = {
        activate : {
            title: 'Активация интеграции'
        },
        deactivate : {
            title: 'Деактивация интеграции'
        },
        remove : {
            title: 'Удаление интеграции'
        },
        confirmation : {
            title: 'эту интеграцию'
        },
        done : {
            activate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];
                self._state.items = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Интеграции',
                            href  : '#crms'
                        },
                        {
                            title : self._state.item.display_name
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.item.type + '-' + self._const.entity, {
                    breadcrumbs          : breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            },
            deactivate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];
                self._state.items = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Интеграции',
                            href  : '#crms'
                        },
                        {
                            title : self._state.item.display_name
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.item.type + '-' + self._const.entity, {
                    breadcrumbs          : breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.page = args.page || self._args.page;
        self._args.title = args.title;
        self._args.id   = args.id   || self._args.id;
    };

    _updateAmoAuthInfo = (e) => {
        let self = this;

        if (e.data.error !== undefined) {
            window.location.reload();
        } else {
            let params = e.data.params;
            if (!params || (params.state.toString() != self._state.popup.state.toString())) {
                new Modal({
                    title   : 'Ошибка',
                    content : Utils.renderProfileTemplate('info', {
                        message  : 'Произошла ошибка, попробуйте еще раз',
                        buttons              : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Хорошо'
                            },
                            two : null
                        }
                    }),
                    confirm : function(args) {
                        args.modal.trigger('close');
                        window.location.reload();
                    }
                });
                return;
            }

            self._elems.$modal.find('[name="crm[code]"]').val(params.code);
            self._elems.$modal.find('[name="crm[subdomain]"]').val(params.referer.substr(0, params.referer.length - '.amocrm.ru'.length));
            self._elems.$modal.find('.button_amo').parent().remove();

            self._elems.$modal.find('.button').removeAttr('disabled');

            new Modal({
                title   : 'Данные для создания интеграции получены',
                content : Utils.renderProfileTemplate('info', {
                    message  : 'Нажмите "Добавить" для завершения создания интеграции и формирования iFacade API Token, который нужно будет добавить при установке виджета в amoCRM',
                    buttons              : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Добавить'
                        },
                        two : null
                    }
                }),
                confirm : function(args) {
                    args.modal.trigger('close');
                    self._elems.$modal.find('.button').trigger('click');
                }
            });
        }

        // 4. Закрываем модальное окно
        self._state.popup.amo.close();
    };

    _bindAmoAuth = () => {
        let self = this;

        self._state.popup.state = Math.random() * (9999999 - 1111111) + 1111111;

        let url = 'https://www.amocrm.ru/oauth?client_id=' + self._const.clientId + '&state=' + self._state.popup.state + '&mode=post_message';
        self._state.popup.amo = window.open(url, 'Предоставить доступ', 'scrollbars, status, resizable, width=750, height=580');

        if (self._state.popup.listener) return;
        self._state.popup.listener = true;
        window.addEventListener('message', self._updateAmoAuthInfo);
    };

    _initPreModal = () => {
        let self = this;

        let fields = {
            type : {
                title    : 'CRM',
                type     : 'select',
                required : true,
                value    : Object.keys(self._state.item).length ? self._state.item.type : '',
                options  : ifacade.constants.crms.types
            },
            display_name : {
                title       : 'Название',
                type        : 'string',
                required    : true,
                value       : Object.keys(self._state.item).length ? self._state.item.display_name : '',
                placeholder : 'Как назовем интеграцию?'
            }
        };

        self._elems.$modal = new Modal({
            title: Object.keys(self._state.item).length ? 'Редактирование CRM' : 'Добавление нового CRM',
            content: Utils.renderProfileTemplate('form', {
                item   : Object.keys(self._state.item).length ? self._state.item : null,
                entity : 'crm',
                fields : fields,
                buttons : null
            }),
            closingConfirmation: true,
            confirm : function(args) {
                let $modal = args.modal;
                let $form = $modal.find('form');
                const type = $form.find('[name="' + self._const.entity + '[type]"]').val();
                const display_name = $form.find('[name="' + self._const.entity + '[display_name]"]').val();

                let validation = new Validation({
                    form : $form
                });

                if (display_name == '') {
                    validation.showErrors({
                        type : 'validation',
                        fields : {
                            display_name : ['Поле обязательно для заполнения']
                        }
                    });

                    return;
                }

                self._state.type = type;
                self._state.display_name = display_name;
                $modal.trigger('close');

                self._initModal();
            }
        });

        self._elems.$modal.find('select[name="crm[type]"] option[value="amo_widget_oauth"]').attr('disabled', 'disabled');
    };

    _initModal = () => {
        let self = this;

        let fields = {};
        if (!Object.keys(self._state.item).length || self._state.item.type == 'amo_widget_oauth') {
            fields = Object.assign(fields, {
                subdomain    : {
                    type     : 'hidden',
                    required : true,
                    value    : Object.keys(self._state.item).length ? self._state.item.options.subdomain     : ''
                },
                code         : {
                    type     : 'hidden',
                    required : true,
                    value    : Object.keys(self._state.item).length ? self._state.item.options.code : ''
                },
                display_name : {
                    title    : 'Название',
                    type     : Object.keys(self._state.item).length ? 'string' : 'hidden',
                    required : true,
                    value    : Object.keys(self._state.item).length ? self._state.item.display_name : self._state.display_name
                }
            });
        }
        else {
            fields = Object.assign(fields, {
                display_name : {
                    title       : 'Название',
                    type        : 'string',
                    required    : true,
                    value       : Object.keys(self._state.item).length ? self._state.item.display_name : '',
                    placeholder : 'Как назовем интеграцию?'
                }
            });
        }

        fields = Object.assign(fields, {
            type : {
                type     : 'hidden',
                required : true,
                value    : self._state.type
            }
        });

        if (self._state.type == 'amo_widget_oauth' || (Object.keys(self._state.item).length && self._state.item.type == 'amo_widget_oauth')) {
            fields = Object.assign(fields, {
                connect : {
                    title       : 'Подключить Amo.CRM',
                    type        : 'button_amo'
                }
            });
        }
        else {
            fields = Object.assign(fields, {
                subdomain : {
                    title       : 'Поддомен',
                    type        : 'string',
                    required    : true,
                    value       : Object.keys(self._state.item).length && self._state.item.options ? self._state.item.options.subdomain : '',
                    placeholder : 'Поддомен в AmoCRM',
                    description : 'Укажите поддомен https://<SUBDOMAIN>.amocrm.ru. Адрес может состоять только из цифр (0-9) и букв латинского алфавита (a-z) в нижнем регистре',
                    additional  : '<div class="js-amo-crm-subdomain">' + 'https://<span>' + (Object.keys(self._state.item).length && self._state.item.options.subdomain != '' ? self._state.item.options.subdomain : '&#8249;SUBDOMAIN&#8250;') + '</span>.amocrm.ru</div>'
                },
                login : {
                    title       : 'Логин',
                    type        : 'string',
                    required    : true,
                    value       : Object.keys(self._state.item).length && self._state.item.options ? self._state.item.options.login : '',
                    placeholder : 'myname@mycompany.ru'
                },
                hash : {
                    title       : 'Ключ API',
                    description : 'Ключ API указан в настройках профиля amoCRM',
                    type        : 'string',
                    required    : true,
                    value       : Object.keys(self._state.item).length && self._state.item.options ? self._state.item.options.hash : '',
                    placeholder : 'ads2442jfsad44f34r2f232'
                }
            });
        }

        self._elems.$modal = new Modal({
            title: Object.keys(self._state.item).length ? 'Редактирование CRM' : 'Добавление нового CRM',
            content: Utils.renderProfileTemplate('form', {
                item   : Object.keys(self._state.item).length ? self._state.item : null,
                entity : 'crm',
                fields : fields,
                buttons : null
            }),
            closingConfirmation: true,
            confirm : function(args) {
                self._bindConfirm(args);
            }
        });

        self._elems.$form = self._elems.$modal.find('form');

        self._elems.$form.find('input[name="crm[subdomain]"]').on('keyup', function(e) {
            e.preventDefault();
            const value = $(this).val().toLowerCase().replace(/[^a-z0-9]/gim,'');
            $(this).val(value);
            $('.js-amo-crm-subdomain span').text(value);
        });

        if (self._state.type == 'amo_widget_oauth') {
            if (!Object.keys(self._state.item).length) {
                self._elems.$modal.find('.button').attr('disabled', 'disabled');

                loader.increase();
                Request.send({
                    path : '/api/pages/tariff',
                    done : function(response) {
                        loader.decrease();

                        if (response.tariff.name != 'professional') {
                            let $field = self._elems.$modal.find('.button_amo').parents('.form-field');
                            $field.empty().html('Установка виджета amoCRM доступна на тарифном плане "Профессиональный". Пожалуйста, оплатите тарифный план: <a href="#tariffs">тарифы</a>');
                            $field.find('a').on('click', function(){
                                self._elems.$modal.trigger('close');
                            });
                        }
                    }
                })
            }

            self._elems.$modal.find('.button_amo').unbind('click').on('click', function(e){
                e.preventDefault();
                self._bindAmoAuth();
            });
        }
    };

    _bindConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        loader.increase();

        Request.send({
            path   : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item.id + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),
            done   : function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return;
                }
                $modal.trigger('close');
                self._elems.$modal = $();
                self._elems.$form  = $();

                self._state.item = response[self._const.entity];

                self._state.item[self._state.item.type] = response[self._state.item.type];

                if (Object.keys(self._state.items).length || self._args.page == Vars.page.index) {
                    window.location.href = '#' + self._const.entities + '/' + self._state.item.id;

                    if (self._state.item.type == 'amo_widget_oauth') {
                        window.location.reload();
                    }
                }
                else {
                    self._state.items = {};

                    let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Главная',
                                href  : '#'
                            },
                            {
                                title : 'Интеграции',
                                href  : '#crms'
                            },
                            {
                                title : self._state.item.display_name
                            }
                        ],
                        dropdown : null,
                        activate : {
                            id        : self._state.item.id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._state.item.type + '-' + self._const.entity, {
                        breadcrumbs          : breadcrumbs,
                        [self._const.entity] : self._state.item
                    }));

                    self._bindElements();
                    self._bindUI();
                }
            }
        });
    };

    _initParamsModal = () => {
        let self = this;

        loader.increase();

        Request.send({
            path : '/api/' + self._const.entities + '/' + self._args.id,
            data : {
                info : 'params'
            },
            done : function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item = response[self._const.entity];
                self._state.item[self._state.item.type] = response[self._state.item.type];

                let title       = '';
                if (!self._state.item[self._state.item.type].is_auth){
                    self._state.item[self._state.item.type].errors.forEach(function(error) {
                        if (error == 'Account not found')
                            title = 'Ошибка авторизации: домен "https://' + self._state.item.options.subdomain + '.amocrm.ru" не найден';
                        else if (error == 'Неверный логин или пароль')
                            title = 'Ошибка авторизации: Неверный логин или API ключ';
                        else if (error == 'Unauthorized')
                            title = 'Ошибка авторизации: Проверьте актуальность API-ключа';
                        else
                            title = 'Ошибка авторизации: ' + error;
                    });
                }
                else {
                    title = 'Редактирование параметров CRM';
                    self._state.isCorrect = true;
                }

                let $modal = new Modal({
                    title: title,
                    content: Utils.renderProfileTemplate(self._state.item.type + '-crm-form', {
                        item    : self._state.item
                    }),
                    closingConfirmation: self._state.isCorrect,
                    confirm : function(args) {
                        let $modal= args.modal;
                        if (!self._state.isCorrect){
                            $modal.trigger('close');
                            return;
                        }
                        self._bindParamsConfirm(args);
                    }
                });

                let $form = $modal.find('form');

                self._state.disabledFields = {
                    contact : {
                        ifacade : [],
                        crm     : []
                    },
                    lead    : {
                        ifacade : [],
                        crm     : []
                    }
                };
                
                self._setDisabledFields({
                    form : $form
                });
                self._state.count = {
                    contact : 0,
                    lead    : 0
                };

                Object.keys(self._state.count).forEach(function(type){
                    self._state.count[type] = (
                        $form.find('.form-group__section[data-name="' + type + '"]:first select[name="crm[' + type + '][ifacade_field][]"] option').length
                        <
                        $form.find('.form-group__section[data-name="' + type + '"]:first select[name="crm[' + type + '][crm_field][]"] option').length
                    )
                        ? $form.find('.form-group__section[data-name="' + type + '"]:first select[name="crm[' + type + '][ifacade_field][]"] option').length
                        : (
                            type == 'lead'
                                ? $form.find('.form-group__section[data-name="' + type + '"]:first select[name="crm[' + type + '][ifacade_field][]"] option').length
                                : $form.find('.form-group__section[data-name="' + type + '"]:first select[name="crm[' + type + '][crm_field][]"] option').length
                        )
                });

                if ($form.find('select[name="crm[contact][ifacade_field][]"]').length >= self._state.count.contact) {
                    $form.find('.form-group__link.add[data-target="contact"]').hide();
                }
                if ($form.find('select[name="crm[lead][ifacade_field][]"]').length >= self._state.count.lead) {
                    $form.find('.form-group__link.add[data-target="lead"]').hide();
                }

                $form.find('.form-group__link.add').unbind('click').on('click', function(e) {
                    e.preventDefault();
                    let target     = $(this).data('target');

                    let $formFields = $(this).parent().prev('.form-group__sections[data-name="crm-fields"]');
                    let $firstField = $formFields.children('.form-group__section:first');

                    let $newField   = $('<div />')
                        .attr('class', $firstField.attr('class'))
                        .html($firstField.html());

                    if ($newField.find('select[name="crm[' + target + '][ifacade_field][]"] option').length == Object.keys(self._state.disabledFields[target].ifacade).length) {
                        $newField.find('select[name="crm[' + target + '][ifacade_field][]"]').val(0);
                    }

                    let flag = false;
                    $newField.find('select[name="crm[' + target + '][ifacade_field][]"] option').each(function() {
                        $(this).removeAttr('selected');
                        if (self._state.disabledFields[target].ifacade.indexOf($(this).val()) != -1) {
                            $(this).attr('disabled', 'disabled');
                        }
                        else if (!flag){
                            $(this).attr('selected', 'selected');
                            flag = true;
                        }
                    });

                    if ($newField.find('select[name="crm[' + target + '][crm_field][]"] option').length == Object.keys(self._state.disabledFields[target].crm).length) {
                        $newField.find('select[name="crm[' + target + '][crm_field][]"]').val(0);
                    }

                    flag = false;
                    $newField.find('select[name="crm[' + target + '][crm_field][]"] option').each(function() {
                        $(this).removeAttr('selected');
                        if (self._state.disabledFields[target].crm.indexOf($(this).val()) != -1) {
                            $(this).attr('disabled', 'disabled');
                        }
                        else if (!flag){
                            $(this).attr('selected', 'selected');
                            flag = true;
                        }
                    });

                    $newField.find('select[name="crm[' + target + '][ifacade_field][]"]').on('change', function(){
                        const value1 = $(this).val();
                        const value2 = $(this).parents('.select').next('.select').find('select').val();
                        const index  = $(this).parents('.form-group__section').index();
                        self._changingParams({
                            form   : $form,
                            value1 : value1,
                            value2 : value2,
                            index  : index
                        });
                    });

                    $newField.find('select[name="crm[' + target + '][crm_field][]"]').on('change', function(){
                        const value1 = $(this).parents('.select').prev('.select').find('select').val();
                        const value2 = $(this).val();
                        const index  = $(this).parents('.form-group__section').index();
                        self._changingParams({
                            form   : $form,
                            value1 : value1,
                            value2 : value2,
                            index  : index
                        });
                    });

                    $newField.find('.input__remove').on('click', function(e){
                        e.preventDefault();
                        self._removeParams({
                            item : $(this),
                            form : $form
                        });
                    });

                    $formFields.append($newField);

                    if (
                        target == 'contact'
                        &&
                        (
                            $form.find('select[name="crm[' + target + '][ifacade_field][]"]').length == self._state.count.contact
                            ||
                            $form.find('select[name="crm[' + target + '][crm_field][]"]').length == self._state.count.contact
                        )
                    ) {
                        $form.find('.form-group__link.add[data-target="contact"]').hide();
                    }

                    if (
                        target == 'lead'
                        &&
                        (
                            $form.find('select[name="crm[' + target + '][ifacade_field][]"]').length == self._state.count.lead
                            ||
                            $form.find('select[name="crm[' + target + '][crm_field][]"]').length == self._state.count.lead
                        )
                    ) {
                        $form.find('.form-group__link.add[data-target="lead"]').hide();
                    }

                    self._setDisabledFields({
                        form : $form
                    });
                });

                $form.find('select[name="crm[contact][ifacade_field][]"], select[name="crm[lead][ifacade_field][]"]').on('change', function(){
                    const value1 = $(this).val();
                    const value2 = $(this).parents('.select').next('.select').find('select').val();
                    const index  = $(this).parents('.form-group__section').index();
                    self._changingParams({
                        form   : $form,
                        value1 : value1,
                        value2 : value2,
                        index  : index
                    });
                });

                $form.find('select[name="crm[contact][crm_field][]"], select[name="crm[lead][crm_field][]"]').on('change', function(){
                    const value1 = $(this).parents('.select').prev('.select').find('select').val();
                    const value2 = $(this).val();
                    const index  = $(this).parents('.form-group__section').index();
                    self._changingParams({
                        form   : $form,
                        value1 : value1,
                        value2 : value2,
                        index  : index
                    });
                });

                $form.find('.input__remove').on('click', function(e){
                    e.preventDefault();
                    self._removeParams({
                        item : $(this),
                        form : $form
                    });
                });

                $form.find('.js-amo-crm-add-field').on('click', function(e){
                    e.preventDefault();

                    let fields = {
                        title : {
                            title    : 'Название поля',
                            type     : 'string',
                            required : true,
                            value    : ''
                        }
                    };

                    new Modal({
                        title: 'Добавление нового поля в amoCRM',
                        content: Utils.renderProfileTemplate('form', {
                            fields : fields,
                            entity : 'field',
                            item   : null,
                            buttons: null
                        }),
                        closingConfirmation: true,
                        confirm : function(args) {
                            let $fieldModal = args.modal;
                            let $fieldForm  = $fieldModal.find('form');
                            if (!$fieldForm.length) return;

                            let validation = new Validation({
                                form : $fieldForm
                            });

                            Request.send({
                                path   : '/api/' + self._const.entities + '/' + self._args.id + '/params/add',
                                method : 'POST',
                                data   : $fieldForm.serialize(),
                                done   : function (response) {
                                    loader.decrease();

                                    if (response.error) {
                                        validation.showErrors(response.error);
                                        return;
                                    }

                                    let fields = response['fields'] ? response['fields'] : null;
                                    if (fields == null){
                                        /*self.profile.callback.error({
                                            fields : {
                                                title : ['Не удалось добавить']
                                            },
                                            type : 'validation'
                                        }, fieldForm, self.profile);*/
                                    }
                                    else {

                                        let $selects = $form.find('select[name="crm[lead][crm_field][]"]');
                                        const title = $fieldForm.find('input[name="field[title]"]').val();
                                        $selects.each(function(){
                                            let $select = $(this);
                                            fields.forEach(function(fieldId){
                                                $('<option />').text(title).val(fieldId + ':::' + title).appendTo($select);
                                            });
                                        });

                                        new Modal({
                                            title   : 'Новое поле добавлено, выберите его из списка',
                                            content : Utils.renderProfileTemplate('info', {
                                                message : '',
                                                buttons : {
                                                    one : {
                                                        class : 'confirm button--edit',
                                                        title : 'Хорошо'
                                                    },
                                                    two : null
                                                }
                                            })
                                        });
                                        $fieldModal.trigger('close');
                                    }
                                }
                            });
                        }
                    });
                });
            }
        });
    };
    
    _setDisabledFields = (args) => {
        let self = this;
        let $form = args.form;

        self._state.disabledFields.contact.ifacade = [];
        $form.find('select[name="crm[contact][ifacade_field][]"] option:selected').each(function(){
            self._state.disabledFields.contact.ifacade.push($(this).val());
        });

        self._state.disabledFields.contact.crm = [];
        $form.find('select[name="crm[contact][crm_field][]"] option:selected').each(function(){
            self._state.disabledFields.contact.crm.push($(this).val());
        });

        $form.find('select[name="crm[lead][ifacade_field][]"] option:selected').each(function(){
            self._state.disabledFields.lead.ifacade.push($(this).val());
        });

        self._state.disabledFields.lead.crm = [];
        $form.find('select[name="crm[lead][crm_field][]"] option:selected').each(function(){
            self._state.disabledFields.lead.crm.push($(this).val());
        });
    };

    _changingParams = (args) => {
        let self = this;

        let $form  = args.form;
        let value1 = args.value1;
        let value2 = args.value2;
        let index  = args.index;

        self._setDisabledFields({
            form : $form
        });

        $form.find('select[name="crm[contact][ifacade_field][]"] option').each(function(){
            if (self._state.disabledFields.contact.ifacade.indexOf($(this).attr('value')) == -1) {
                $(this).removeAttr('disabled');
            }
        });
        $form.find('select[name="crm[contact][ifacade_field][]"] option[value="' + value1 + '"]').each(function(){
            if (index != $(this).parents('.form-group__section').index()) {
                $(this).attr('disabled', 'disabled');
            }
        });

        $form.find('select[name="crm[contact][crm_field][]"] option').each(function(){
            if (self._state.disabledFields.contact.crm.indexOf($(this).attr('value')) == -1) {
                $(this).removeAttr('disabled');
            }
        });
        $form.find('select[name="crm[contact][crm_field][]"] option[value="' + value2 + '"]').each(function(){
            if (index != $(this).parents('.form-group__section').index()) {
                $(this).attr('disabled', 'disabled');
            }
        });

        $form.find('select[name="crm[lead][ifacade_field][]"] option').each(function(){
            if (self._state.disabledFields.lead.ifacade.indexOf($(this).attr('value')) == -1) {
                $(this).removeAttr('disabled');
            }
        });
        $form.find('select[name="crm[lead][ifacade_field][]"] option[value="' + value1 + '"]').each(function(){
            if (index != $(this).parents('.form-group__section').index()) {
                $(this).attr('disabled', 'disabled');
            }
        });

        $form.find('select[name="crm[lead][crm_field][]"] option').each(function(){
            if (self._state.disabledFields.lead.crm.indexOf($(this).attr('value')) == -1) {
                $(this).removeAttr('disabled');
            }
        });
        $form.find('select[name="crm[lead][crm_field][]"] option[value="' + value2 + '"]').each(function(){
            if (index != $(this).parents('.form-group__section').index()) {
                $(this).attr('disabled', 'disabled');
            }
        });
    };
    
    _removeParams = (args) => {
        let self = this;

        let $form = args.form;
        let $item = args.item;

        if ($form.find('.form-group__section').length){
            new Modal({
                title: 		'Действительно хотите удалить пару соответсвий?',
                content: 	Utils.renderProfileTemplate('info', {
                    message : '',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Да'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Отмена'
                        }
                    }
                }),
                confirm : function(args) {
                    let $modal = args.modal;
                    $modal.trigger('close');

                    $item.parents('.form-group__section').remove();

                    $form.find('select[name="crm[contact][ifacade_field][]"]').each(function(){
                        const value1 = $(this).val();
                        const value2 = $(this).parents('.select').next('.select').find('select').val();
                        const index = $(this).parents('.form-group__section').index();
                        self._changingParams({
                            form   : $form,
                            value1 : value1,
                            value2 : value2,
                            index  : index
                        });
                    });

                    if ($form.find('select[name="crm[contact][ifacade_field][]"]').length < self._state.count.contact) {
                        $form.find('.form-group__link.add[data-target="contact"]').show();
                    }

                    if ($form.find('select[name="crm[lead][ifacade_field][]"]').length < self._state.count.lead) {
                        $form.find('.form-group__link.add[data-target="lead"]').show();
                    }
                }
            });
        }
        else {
            new Modal({
                title: 		'Нельзя удалить все соответствия. Хотя бы одно должно быть',
                content: 	Utils.renderProfileTemplate('info', {
                    message : '',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Хорошо'
                        },
                        two : null
                    }
                })
            });
        }
    };

    _bindParamsConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        let errors = 0;
        $form.find('select').each(function(){
            if ($(this).attr('required') != undefined && !$(this).val()) {
                errors++;

                let $field = $(this).parents('.form-field');

                $field.addClass('error');

                if (!$field.find('.form-field__message').length) {
                    $field.append(
                        $('<div />')
                            .addClass('form-field__message')
                    )
                }
                $field.find('.form-field__message').each(function() {
                    $(this).removeClass('hidden').show().html('Поле обязательно для заполнения');
                });

                $field.css({
                    'background': '#f3d0d7'
                });

                setTimeout(function(){
                    $field.css({
                        'background': 'transparent'
                    });
                }, 4000)
            }
        });

        if (errors) {
            return;
        }

        loader.increase();

        Request.send({
            path   : '/api/' + self._const.entities + '/' + self._args.id + '/params/edit',
            method : 'POST',
            data   : $form.serialize(),
            done   : function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return;
                }

                self._state.item = response[self._const.entity];
                self._state.item[self._state.item.type]  = response[self._state.item.type];
                $modal.trigger('close');

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Интеграции',
                            href  : '#crms'
                        },
                        {
                            title : self._state.item.display_name
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.item.type + '-' + self._const.entity, {
                    breadcrumbs          : breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if (!self._elems.$content.length) return;

        self._elems.$create = self._elems.$content.find('.js-profile-crm-create');
        self._elems.$edit = self._elems.$content.find('.js-profile-crm-edit');
        self._elems.$params = self._elems.$content.find('.js-profile-crm-params-edit');

    };

    _bindActions = () => {
        let self = this;

        new Action({
            id       : self._state.item.id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            self     : self
        });
    };

    _bindCreateMax = () => {
        let self = this;

        const count = parseInt(self._elems.$create.data('count'));
        const max   = parseInt(self._elems.$create.data('max'));

        if (count < max && max != 0) return true;

        if (max == 0) {
            new Modal({
                title: ifacade.constants.messages.crms.access.max.title,
                content: Utils.renderProfileTemplate('info', {
                    message : ifacade.constants.messages.crms.access.start.message,
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Хорошо'
                        },
                        two : null
                    }
                }),
                confirm : function(args) {
                    args.modal && args.modal.trigger('close');
                }
            });

            return false;
        }

        new Modal({
            title: ifacade.constants.messages.crms.access.max.title,
            content: Utils.renderProfileTemplate('info', {
                message : ifacade.constants.messages.crms.access.max.message.replace('%max%', max),
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Хорошо'
                    },
                    two : null
                }
            }),
            confirm : function(args) {
                args.modal && args.modal.trigger('close');
            }
        });

        return false;
    };

    _bindCreate = () => {
        let self = this;

        if (!self._elems.$create.length) return;

        self._elems.$create.unbind('click').on('click', function(e){
            e.preventDefault();
            if (!self._bindCreateMax()) return;

            self._initPreModal();
        });
    };

    _bindEdit = () => {
        let self = this;

        if (!self._elems.$edit.length) return;

        self._elems.$edit.unbind('click').on('click', function(e){
            e.preventDefault();

            if (Object.keys(self._state.item).length) {
                self._state.type = self._state.item.type;
                self._initModal();
            }
            else {
                self._initPreModal();
            }
        })
    };

    _bindParams = () => {
        let self = this;

        if (!self._elems.$params.length) return;

        self._elems.$params.unbind('click').on('click', function(e){
            e.preventDefault();

            self._initParamsModal();
        })
    };

    _bindUI = () => {
        let self = this;

        self._bindCreate();
        self._bindEdit();
        self._bindParams();
        self._bindActions();
    };

    _list = () => {
        let self = this;

        loader.increase();
        Request.send({
            queue: [
                {
                    path: '/api/' + self._const.entities
                },
                {
                    path: '/api/accesses?only=' + self._const.entities
                }
            ],
            done: function (response, extraResponse) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items = response[self._const.entities] ? response[self._const.entities] : {};

                const accesses    = extraResponse.accesses;

                if (!accesses[self._const.entities].enabled) {
                    new Modal({
                        title: ifacade.constants.messages.crms.access.base.title,
                        content: Utils.renderProfileTemplate('info', {
                            message : ifacade.constants.messages.crms.access.base.message,
                            buttons : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Хорошо'
                                },
                                two : null
                            }
                        }),
                        confirm : function(args) {
                            args.modal && args.modal.trigger('close');
                            window.location.href = '#';
                        }
                    });

                    return false;
                }

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : breadcrumbs,
                    [self._const.entities] : self._state.items,
                    accesses               : accesses
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;

        loader.increase();
        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.id,
            done: function (response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Интеграции',
                            href  : '#crms'
                        },
                        {
                            title : self._state.item.display_name
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.item.type + '-' + self._const.entity, {
                    breadcrumbs          : breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        self._bindElements();

        if (self._args.page === Vars.view.list) {
            self._list();
        }
        else if (self._args.page === Vars.view.item) {
            self._item();
        }
    }
}

export default Crm;